// Formats an ISO date (yyyy-mm-dd or full ISO timestamp) as dd-mm-yyyy.
// Returns '—' when empty; returns the original value if it can't be parsed.
export const formatOtrDate = (value) => {
  if (!value) return '—';
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return String(value);
};